import { render, staticRenderFns } from "./pins.vue?vue&type=template&id=2728805d&scoped=true"
import script from "./pins.vue?vue&type=script&lang=js"
export * from "./pins.vue?vue&type=script&lang=js"
import style0 from "./pins.vue?vue&type=style&index=0&id=2728805d&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2728805d",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/clients/client/players/player/pins.vue
// module id = bCLi
// module chunks = 0